import { createSelector } from '@ngrx/store';

import { homeBatteryFunnelKey } from './homebattery-funnel.reducer';
import { selectFehHomebatteryState } from '../feh-homebattery.state';

export const selectHomeBatteryFunnelSettings = createSelector(
  selectFehHomebatteryState,
  (state) => state[homeBatteryFunnelKey]
);

export const selectHomeBatteryTrackingId = createSelector(
  selectHomeBatteryFunnelSettings,
  ({ trackingId }) => trackingId
);
